<template lang="pug">
-
  // 環形圖共用的屬性值
  const ringAttributes = {
    ':settings': 'settings.ring',
    ':legend-visible': 'false',
    ':judge-width': 'true',
    ':toolbox': 'toolbox',
    height: '240px',
  }
mixin dataEmpty(object)
  v-fade-transition
    .filter(v-if=`getIsObjectEmpty(${object}) || isLoading`)
      Loader(v-if='isLoading')
      .empty(v-else)

v-layout(fill-height wrap)
  //- 組別選單 Tab
  v-flex(xs12)
    v-tabs.mb-2(slider-color='primary' :value='levelList.findIndex(_ => _ === currentLevel)')
      v-tab(v-for='(i, index) in levelList' :key='index' @click='currentLevel = i') {{ $t(convertLevelText(i)) }}
  v-flex.mb-3(xs12 sm6 :lg6='!isPaymentAmountShow' :lg4='isPaymentAmountShow')
    h5 {{ currentLevelText }}表單數
    VeRing&attributes(ringAttributes)(
      :data='groupChartData'
      :colors='colors.group'
      :events='groupChartEvents'
    )
      +dataEmpty('groupChartData')
  v-flex.mb-3(xs12 sm6 :lg6='!isPaymentAmountShow' :lg4='isPaymentAmountShow')
    h5 {{ currentLevelText }}繳費狀態
    VeRing&attributes(ringAttributes)(
      :data='statusChartData'
      :colors='colors.status'
      :events='statusChartEvents'
    )
      +dataEmpty('statusChartData')
  v-flex.mb-3(xs12 sm6 lg4 v-if='isPaymentAmountShow')
    h5 繳費金額
    v-data-table.payment-table(:items='paymentAmountList' :headers='headers' :hide-actions='paymentAmountList.length <= 5' flat :rowsPerPageItems='[5]' rows-per-page-text='' disable-initial-sort)
      template(v-slot:items='props')
        td.dense: span.label {{ props.item.label }}
        td.dense.text-xs-right $ {{ props.item.value }}
      template(v-slot:footer)
        td.primary--text: strong 總計
        td.primary--text.text-xs-right: strong $ {{ paymentAmountTotal }}
  v-fade-transition(hide-on-leave)
    v-flex.mb-3(xs12 v-if='minLevel === currentLevel')
      h5 {{ currentLevelText }}報名狀況
      VeLine(
        :judge-width='true',
        :data='historyChartData'
        :settings='settings.line'
        :colors='colors.group'
        :loading='isLoading'
        :extend='extend.line'
        :data-zoom='dataZoom'
        :toolbox='toolbox'
        height='300px'
        :textStyle='textStyle'
        :legend='legend'
      )
        +dataEmpty('historyChartData')
  DebugCodeBlock(:value='dashboard')
</template>

<script>
import Loader from '@/components/Loader.vue'

import VeRing from 'v-charts/lib/ring.common'
import VeLine from 'v-charts/lib/line.common'
import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/toolbox'

import palette from 'google-palette'
import moment from 'moment'

export default {
  name: 'Dashboard',
  props: {
    dashboard: {
      default: null,
      type: Object,
    },
  },
  data () {
    // 圖表配色方案
    this.colors = {
      group: palette(['cb-Spectral'], 8).map(_ => `#${_}`),
      status: ['#4CAF50', '#BDBDBD', '#78909C', ...palette(['cb-Spectral'], 8).map(_ => `#${_}`)],
    }
    this.headers = [
      { text: '組別', value: 'label', sortable: false },
      { text: '金額', value: 'value', align: 'right' },
    ]
    this.groupChartEvents = {
      click: e => this.toForm({ groupIndex: e.dataIndex }),
    }
    this.statusChartEvents = {
      click: e => this.toForm({ statusIndex: e.dataIndex }),
    }
    this.toolbox = {
      feature: { saveAsImage: {} },
    }
    return {
      isInitialized: false,
      currentLevel: null,
    }
  },
  methods: {
    // 將物件所有 key 取出排序後加入陣列
    getGroupKeysFromObject (_) {
      return Object.keys(_)
        .map(_ => +_) // 將組別編號轉換為 Number
        .filter(_ => !isNaN(_)) // 篩選掉非數字者
        .sort((a, b) => a - b) // 由大->小排序
    },
    // 快速跳轉至 Form
    toForm (_) {
      const level = this.currentLevel
      const groupInfo = this.groupChartData.rows[_.groupIndex]
      const statusInfo = this.statusChartData.rows[_.statusIndex]

      if (!level) return

      const query = {}
      if (groupInfo) query.group = groupInfo.key
      if (statusInfo) query.status = statusInfo.key

      this.toLatestForm(query, level)
    },
    convertObjectToChartData (name, method) {
      const dashboard = this.dashboard
      if (!dashboard || !dashboard[name]) return {}

      const group = dashboard[name][this.currentLevel]
      if (!group) return {}

      const keys = this.getGroupKeysFromObject(group)
      const rows = keys.map(key => {
        const label = method(key)
        const value = group[key]
        return { value, label, key }
      }).filter(_ => _.value > 0)

      const columns = ['label', 'value', 'key']

      return { columns, rows }
    },
    getRandomValue () {
      return Math.floor(Math.random() * 50)
    },
    // 正規化日期格式，將 timestamp 轉換成當天的 00:00
    normalizeTimestamp (_) {
      const format = 'YYYY/MM/DD'
      const dateText = moment(_).format(format)
      return +moment(dateText, format).format('x')
    },
    convertTime (_) {
      return moment(_).format('Y.M.D')
    },
    getIsObjectEmpty (_) {
      return Object.keys(_).length === 0
    },
  },
  computed: {
    // 各組數量(📈圖表用)
    groupChartData () {
      return this.convertObjectToChartData('groupCount', this.convertGroupText)
    },
    // 表單狀態(📈圖表用)
    statusChartData () {
      return this.convertObjectToChartData('statusCount', this.convertFormStatusText)
    },
    // 報名時間(📈圖表用)
    historyChartData () {
      const dashboard = this.dashboard
      if (!dashboard || !dashboard.formHistory) return {}
      const history = dashboard.formHistory[this.currentLevel]
      if (!history) return {}

      const dates = {} // 以日期作為 key 的物件
      let groups = [] // 存在的組別列表

      const maxTimestamp = this.normalizeTimestamp(Math.max(...history.map(_ => +_.timestamp)))
      const minTimestamp = this.normalizeTimestamp(Math.min(...history.map(_ => +_.timestamp)))

      for (let i = minTimestamp; i <= maxTimestamp; i += 86400000) {
        dates[this.normalizeTimestamp(i)] = {}
      }

      history.sort((a, b) => a.timestamp - b.timestamp) // 依照報名時間排序
        .forEach(_ => { // 迭代所有項目
          const timestamp = this.normalizeTimestamp(_.timestamp) // 正規化日期格式
          const group = this.convertGroupText(_.group)

          if (!dates[timestamp]) dates[timestamp] = {}
          if (!dates[timestamp][group]) dates[timestamp][group] = 1
          else dates[timestamp][group]++

          if (!groups.some(g => g === +_.group)) groups.push(+_.group)
        })

      const rows = Object.keys(dates).map(_ => +_).sort((a, b) => a - b).map(date => {
        const item = dates[date]
        item.日期 = this.convertTime(date) // 轉換成日期字串
        return item
      })

      groups = groups.sort((a, b) => a - b).map(_ => {
        const groupName = this.convertGroupText(_)
        rows.forEach(item => {
          if (!item[groupName]) item[groupName] = 0
        })
        return groupName
      })

      const columns = ['日期', ...groups]

      return { columns, rows }
    },
    // 付款金額
    paymentAmountList () {
      if (!(this.dashboard && this.dashboard.paymentAmount)) return []
      const group = this.dashboard.paymentAmount
      const keys = this.getGroupKeysFromObject(group)

      return keys.map(key => {
        return { label: this.convertGroupText(key), value: group[key], key }
      })
    },
    // 總計付款金額
    paymentAmountTotal () {
      if (!this.isPaymentAmountShow) return 0
      let total = 0
      this.paymentAmountList.forEach(_ => { total += _.value })
      return total
    },
    // 是否為載入中
    isLoading () {
      return !this.dashboard
    },
    // 是否顯示付款金額圖表
    isPaymentAmountShow () {
      return !!(this.dashboard && this.dashboard.paymentAmount && this.paymentAmountList.length > 0)
    },
    // 是否顯示報名時間折線圖 (暫不使用)
    isFormHistoryShow () {
      return !!(this.dashboard && this.dashboard.formHistory)
    },
    // 當前選中賽制的字串
    currentLevelText () {
      return this.$t(this.convertLevelText(this.currentLevel))
    },
    // 賽制列表
    levelList () {
      const dashboard = this.dashboard
      if (!dashboard || !dashboard.groupCount) return []
      return this.getGroupKeysFromObject(dashboard.groupCount)
    },
    minLevel () {
      const list = this.levelList
      return list.length > 0 ? list[0] : null
    },
    settings () {
      const isDark = this.isDarkTheme
      return {
        ring: {
          radius: [65, 80],
          offsetY: 120,
          label: {
            formatter: ['{label|{b}}', '{value|{c}筆}'].join('\n'),
            rich: {
              label: {
                height: 20,
                padding: [0, 5, 0, 5],
                fontWeight: 'bold',
                backgroundColor: '#1e1e1e',
                borderRadius: 50,
              },
              value: {
                padding: [5, 5, 2, 5],
                color: isDark ? 'white' : 'black',
                fontWeight: '400',
              },
            },
          },
          labelLine: { length: 10, length2: 5 },
        },
        line: {
          yAxisType: 'normal',

        },
      }
    },
    extend () {
      const isDark = this.isDarkTheme
      const splitLineStyle = isDark ? { lineStyle: { opacity: 0.2 } } : { }

      return {
        line: {
          series: {
            type: 'line',
            smooth: 0,
            symbol: 'circle',
            showSymbol: false,
          },
          yAxis: {
            splitLine: splitLineStyle,
          },
        },
      }
    },
    textStyle () {
      const isDark = this.isDarkTheme
      return {
        color: isDark ? 'white' : 'black',
        fontWeight: '400',
      }
    },
    legend () {
      const textStyle = this.textStyle
      return { textStyle }
    },
    dataZoom () {
      const textStyle = this.textStyle
      return {
        type: 'slider',
        start: 0,
        end: 100,
        textStyle,
      }
    },
  },
  watch: {
    dashboard () {
      if (!this.isInitialized) {
        this.isInitialized = true // 已初始化
        this.currentLevel = Math.max(...this.levelList) // 設賽制為最新
      }
    },
  },
  components: {
    Loader,
    VeRing,
    VeLine,
  },
}
</script>

<style scoped lang="sass">
h5
  text-align: center
  margin-bottom: 1rem

.filter
  position: absolute
  left: 0
  right: 0
  top: 0
  bottom: 0
  display: flex
  justify-content: center
  align-items: center
  color: #888
  font-size: 14px
  .empty
    &::before
      content: '尚無資料'
      font-style: italic
</style>
